import { getCountryFromUrl } from '~/core/i18n/functions'
import { MT_INFO_URL, MT_PROFILE_URL } from '~/core/i18n/constants'

const currentCountry = getCountryFromUrl(new URL(window.location.href))

export const PD_URL = `https://${process.env.apiUrl || 'prodoctorov.ru'}`
export const PT_URL = `https://${process.env.ptUrl || 'protabletky.ru'}`
export const PB_URL = `https://${process.env.pbUrl || 'probolezny.ru'}`
export const MO_URL = `https://${process.env.moUrl || 'medotvet.me'}`
export const INFO_URL = currentCountry && MT_INFO_URL[currentCountry]
  ? MT_INFO_URL[currentCountry]
  : `https://${process.env.infoUrl || 'info.medtochka.ru'}`
export const ML_URL = 'https://medlock.ru'
export const PROFILE_URL = currentCountry && MT_PROFILE_URL[currentCountry]
  ? MT_PROFILE_URL[currentCountry]
  : `https://${process.env.profileUrl || 'profile.medtochka.ru'}`
export const FINGERPRINT_URL = `https://${process.env.fingerprintUrl || 'r.medtochka.ru/api/v1/fingerprint'}`
export const PAY_PD_URL = 'https://pay-stage.prodoctorov.com'
export const LANDING_URL = `https://${process.env.landingUrl || 'medtochka.ru'}`
export const JITSI_MEET_DOMAIN = process.env.jitsiMeetDomain || 'meet.medtochka.ru'

export const APP_LINKS = {
  /*
  * Универсальный SmartLink в приложение (на главную). Подходит для всех ОС. Если нет приложения - откроется стор.
  * */
  smartAppLink: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=1182945020236331076&referrer=reattribution%3D1',
  universalStoreLink: 'https://redirect.appmetrica.yandex.com/serve/605858350789359358',
  appGalleryStoreLink: 'https://appgallery.huawei.ru/app/C106868625',
  stubs: {
    healthDiary: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=822494628845487565&referrer=reattribution%3D1',
    dentalTreatmentPlan: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=101378131935434459&referrer=reattribution%3D1',
    edmDocuments: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=1110674334214549339&referrer=reattribution%3D1',
    femaleCalendar: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=749892139537723374&referrer=reattribution%3D1',
    finance: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=605745220595815479&referrer=reattribution%3D1',
    family: 'https://4133365.redirect.appmetrica.yandex.com/profile/?appmetrica_tracking_id=534416630231380460&referrer=reattribution%3D1',
    notifications: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=1110439721626060783&referrer=reattribution%3D1',
    createRate: {
      doctor: {
        fromPastAppointment: 'https://4133365.redirect.appmetrica.yandex.com/create-review/doctor/?appmetrica_tracking_id=534325154977757417&referrer=reattribution%3D1',
        fromAppointment: 'https://4133365.redirect.appmetrica.yandex.com/create-review/doctor/?appmetrica_tracking_id=606382751918154944&referrer=reattribution%3D1',
        fromWaitingRate: 'https://4133365.redirect.appmetrica.yandex.com/create-review/doctor/?appmetrica_tracking_id=1182843504657706793&referrer=reattribution%3D1',
        default: 'https://4133365.redirect.appmetrica.yandex.com/create-review/doctor/?appmetrica_tracking_id=1182872479245346528&referrer=reattribution%3D1',
      },
      lpu: {
        default: 'https://4133365.redirect.appmetrica.yandex.com/create-review/clinic/?appmetrica_tracking_id=1038831562361155559&referrer=reattribution%3D1',
      },
    },
  },
  analysis: {
    stage: 'https://redirect.appmetrica.yandex.com/serve/533616802983371877',
    prod: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=101272218830409196&referrer=reattribution%3D1',
  },
  phoneChange: 'https://4133365.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=678094159445241108&referrer=reattribution%3D1',
} as const
